import { useEffect } from 'react';

import { getAnonymousId } from '~/domains/analytics';
import { hasMixpanelFlags } from '~/domains/feature-flags/featureFlagSource';
import mixpanelFlagsClient from '~/domains/feature-flags/mixpanel/mixpanelClient';
import { isInternalEmail, isTesterEmail } from '~/domains/feature-flags/userAttributes';
import isWebView from '~/utils/isWebView';

export function MixpanelFlagsBridge({ userId, email }: { userId?: string; email?: string }) {
  useEffect(() => {
    if (!hasMixpanelFlags()) return;

    const identity = {
      userId,
      anonymousId: getAnonymousId(),
      isInternal: isInternalEmail(email),
      isTester: isTesterEmail(email),
      isWebView: isWebView(),
    };

    mixpanelFlagsClient.start(identity);
    mixpanelFlagsClient.setIdentity(identity);
  }, [userId, email]);

  return null;
}
